import React, { useEffect, useState } from 'react'
import { Tooltip } from 'antd'
import 'moment/locale/zh-cn'
import _lodash,{ get } from 'lodash'
import styles from './index.module.less'
import {QuestionCircleOutlined} from '@ant-design/icons'
import { numFormat } from '../../../public/utils'
import { getSettlePriceTooltipText } from '../utils'

const CooperationInformation = (props) => {
  const [detailsData, setdetailsData] = useState(JSON.parse(sessionStorage.getItem('detailsData')))
  const [twoType,setTwoType] = useState(null) 

  useEffect(()=>{
    getTwoType()
  },[])

  const getTwoType=()=>{
    var goodsIsImport = get(detailsData,'item_info.is_import')
    var goodsIsCrossBorder = get(detailsData,'item_info.is_cross_border')
    var supplierTradeType = get(detailsData,'item_info.trade_type')
    var twoType = null
    //1：当商品是进口+非海淘，且供应商的贸易类型是进口：删除含税结算单价，显示贸易术语，工厂出厂价，含税结算成本，税率随着贸易术语变(DDP是0，其他是13)（如是oem品牌？，则显示是否品牌字段，是则带出以下必填字段:品牌费含税单价，币种，品牌商）
    //2：供应商的贸易类型是国内贸易时：含税结算成本（如是oem品牌？，则显示是否品牌字段，是则带出以下必填字段:品牌费含税单价，币种，品牌商）
    //3：当商品是海淘，且供应商的贸易类型是跨境贸易时：加贸易术语（必填），含税结算成本
    if(!goodsIsCrossBorder&&goodsIsImport&&supplierTradeType=='CommonJKTrade'){
      twoType = 1
    }
    if(supplierTradeType=='GNTrade'){
      twoType = 2
    }
    if(goodsIsCrossBorder&&supplierTradeType=='KJTrade'){
      twoType = 3
    }
    setTwoType(twoType)
  }

  return (
    <div>
      <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
        <div style={{ width: '100%' }}>
          <div className={styles.total_title}>
            <span className={styles.titles}>合作政策</span>
          </div>
          <div className={styles.public_info}>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>经营属性：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.operation === 'direct' ? '经销' : '代销' : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>是否独家销售：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.is_one_sale === 1 ? '是' : '否' : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>铺货方式：</span>
              <span className={styles.public_span_style}>
                {detailsData.item_info.distribute_type === '金额' && '¥'}
                {detailsData && detailsData.item_info ? detailsData.item_info.distribute_number : '--'}</span>
              <span>
                {detailsData.item_info.distribute_type === '盒数' && '盒'}
              </span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}></span>推广政策：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.promote_desc ? detailsData.item_info.promote_desc : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}></span>
                <Tooltip title="买几赠几+活动周期"><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>采购活动：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.purchase_desc ? detailsData.item_info.purchase_desc : '--'}</span>
            </section>
          </div>

          <div className={styles.total_title}>
            <span className={styles.titles}>结算政策</span>
          </div>

          <div className={styles.public_info}>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>账期：</span>
              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.pay_type : '--'}</span>
              {detailsData && (detailsData.item_info.pay_type === '固定账期' || detailsData.item_info.pay_type === '实销实结') ? (
                <span>{detailsData ? '+' + detailsData.item_info.pay_day + '天' : '--'}</span>
              ) : (
                <span>{detailsData ? detailsData.item_info.pay_day : '--'}</span>
              )}
            </section>
            {
              [1,3].includes(twoType)&&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>贸易术语：</span>
                <span className={styles.public_span_style}>{get(detailsData, 'item_info.trade_code') || '--'}</span>
              </section>
            }


            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>税率：</span>
              <span className={styles.public_span_style}>{detailsData && (detailsData.item_info.tax_rate||detailsData.item_info.tax_rate=='0') ? detailsData.item_info.tax_rate + '%' : '--'}</span>
            </section>

            {
              twoType == 1 &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>工厂出厂价：</span>
                  <span className={styles.public_span_style}>
                    {detailsData.item_info.base_price}
                    <span style={{ margin: '0 4px' }}>{detailsData.item_info.currency_name}</span>
                  </span>
              </section>
            }

            {
              twoType != 1 &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>含税结算单价：</span>
                <span className={styles.public_span_style}>
                  {detailsData.item_info.base_price}
                  <span style={{ margin: '0 4px' }}>{detailsData.item_info.currency_name}</span>
                  {
                    !twoType&&
                    <span>({detailsData && (detailsData.item_info.settle_price || detailsData.item_info.settle_price == '0') ? '¥' + numFormat(detailsData.item_info.settle_price) : '--'})</span>
                  }
                </span>
              </section>
            }

            {
              [1,2].includes(twoType)&&get(detailsData, 'item_info.is_oem_brand') &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>是否有品牌使用费：</span>
                  <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.is_have_brand_fee === 1 ? '是' : '否' : '--'}</span>
              </section>
            }
            {
              [1, 2].includes(twoType) &&get(detailsData, 'item_info.is_oem_brand') && get(detailsData, 'item_info.is_have_brand_fee') &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>品牌费含税单价：</span>
                <span className={styles.public_span_style}>
                  {detailsData.item_info.brand_fee}
                  <span style={{ margin: '0 4px' }}>{detailsData.item_info.brand_currency_name}</span>
                </span>
              </section>
            }
            {
              [1, 2].includes(twoType) &&get(detailsData, 'item_info.is_oem_brand') && get(detailsData, 'item_info.is_have_brand_fee') &&
                <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>品牌方：</span>
                  <span className={styles.public_span_style}>
                    {detailsData.item_info.brand_supplier_name}
                  </span>
                </section>
            }
           

            {
              twoType &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>
                  {getSettlePriceTooltipText(twoType)}
                  含税结算成本：</span>
                <span className={styles.public_span_style}>
                ￥{detailsData.item_info.settle_price}
                </span>
              </section>
            }

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>计价单位：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info.price_unit ? detailsData.item_info.price_unit : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>
                <Tooltip title="给工厂下订单至供应商入库时间"><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>生产周期：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.produce_cycle + '天' : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>
                <Tooltip title="供应商发货到视客入库时间"><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>发货天数：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.delivery_day + '天' : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>
              建议零售价：
              </span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? '¥' + detailsData.item_info.sale_price : '--'}</span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>
                <Tooltip
                  title={<div>
                    <div>1.实物投诉：售后商品出现问题处理，需要将货物寄回</div>
                    <div>2.无实物投诉：售后商品出现问题处理，不需要将货物寄回，视客可提供顾客信息，供应商可按投诉信息核销</div>
                    <div>3.减账：直接从货款扣除相应金额</div>
                    <div>4.换货：供应商提供新的货物</div></div>
                  }>
                  <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>售后处理方式：</span>

              <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.is_supply_complaint === 1 ? '无实物投诉' + '-' : '实物投诉' + '-' : '--'}</span>
              <span>{detailsData ? detailsData.item_info.after_sale_problem : ''}</span>
            </section>
          </div>

          <div className={styles.total_title}>
            <span className={styles.titles}>返利政策</span>
          </div>

          <div className={styles.public_info}>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>有无返利：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.is_rebate === 1 ? '有' : '无' : '--'}</span>
            </section>

            <section className={styles.publicsection} style={{display: detailsData.item_info.is_rebate === 1 ? 'inline-block' : 'none'}}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>返利点数：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.rebate_point + '%' : '--'}</span>
            </section>

            <section className={styles.publicsection} style={{display: detailsData.item_info.is_rebate === 1 ? 'inline-block' : 'none'}}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>
                <Tooltip title={<div>
                  <div>1.含税：按照含税价格计算返点</div>
                  <div>2.不含税：按照不含税价格计算返点</div>
                </div>}><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>返利基数：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.rebate_base === 'no_tax' ? '不含税' : '含税' : '--'}</span>
            </section>

            <section className={styles.publicsection} style={{display: detailsData.item_info.is_rebate === 1 ? 'inline-block' : 'none'}}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>
            返利生成时间点：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.rebate_note === 'return_money' ? '回款' : '进货' : '--'}</span>
            </section>

            <section className={styles.publicsection} style={{display: detailsData.item_info.is_rebate === 1 ? 'inline-block' : 'none'}}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>
                <Tooltip title={<div>
                  <div>1.减账：最近一期到期应付款中扣减</div>
                  <div>2.货返：用商品结算</div>
                  <div>3.现金打款：现金电汇</div>
                </div>}><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>兑现方式：</span>
              <span className={styles.public_span_style}>{detailsData && detailsData.item_info ? detailsData.item_info.rebate_type === 'reduce' ? '减账'
                : detailsData.item_info.rebate_type === 'goods' ? '货返' : '现金打款' : '--'}</span>
            </section>
          </div>

        </div>
      </div>
    </div>
  )
}
export default CooperationInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/newproductdetails/cooperation-information.js